import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { Button, CircularProgress, IconButton, Skeleton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { Input } from 'antd';
import CloseIcon from '@mui/icons-material/Close';
import "../styles/Cart.css"
import { Rating } from "@mui/material";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import TextArea from 'antd/es/input/TextArea';

export default function Materials({propsData,tab}) {

  let[CartMaterials,handleCartMaterials]=useState([])
let [errorMaterials,setErrorErrorMaterials]=useState(false)
const location = useLocation()
const [routes,setRoutes]=useState(location.pathname.split("/"))

useEffect(()=>{
  setErrorErrorMaterials(true)
  axios.get(`${process.env.REACT_APP_URL}/api/user/Get_Cart`, //proxy uri
  {
     headers: {
        authorization:`Bearer ${ propsData.userData?.token }`,
        'Content-Type': 'application/json'
     } 
  })
  .then(res=>{
    console.log(res.data);
    handleCartMaterials(res.data)
    setErrorErrorMaterials(false)
  })
  .catch(error=>{
    console.log(error);
  })
},[propsData.equilizer,location])
let sampleErrorMaterial=[1,2,3,4,5]


  return (
        <div className={`cartMaterial`}>
                <h1>My Cart</h1>
                {!errorMaterials?
                  <div className='cartMaterialAll'>
                      {CartMaterials.length===0&&<div style={{marginTop:"30vh",opacity:0.6}}>Nothing is in your cart</div>}
                      {CartMaterials?.map((e,index)=>{
                            return <EachMaterials propsData={propsData} item={e} key={index}/>
                      })}
                  </div>:
                  <div className='cartMaterialAll'>
                       {sampleErrorMaterial.map(e=>{
                        return <Skeleton  variant="rounded"  width={210} height={150}  />
                       })}
                  </div>
                }
          </div>
  )
}

const EachMaterials=({item,propsData})=>{

  let [AveregaRate,HandleAveregaRate]=useState(null)
  useEffect(()=>{
    const sum = item.reviews.reduce((acc, num) => acc + num.rate, 0);
    HandleAveregaRate(sum / item.reviews.length);

  },[item.reviews])
  
  function formatNumberWithCommas(number) {
    // Convert the number to a string
    const numberString = number.toString();
  
    // Split the string into integer and decimal parts (if any)
    const parts = numberString.split('.');
  
    // Format the integer part with commas
    const formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
    // Combine the formatted integer with the decimal part (if any)
    const formattedNumber = parts.length > 1 ? formattedInteger + '.' + parts[1] : formattedInteger;
  
    return formattedNumber;
  }

  let [AddedToCart,HandleAddedToCart]=useState(propsData.userData?.data?.cart?.includes(item?._id))
  let [equilizer,setEquilizer]=useState(0)
  //console.log(propsData.userData?.data?.cart);

  useEffect(()=>{
      axios.get(`${process.env.REACT_APP_URL}/api/user/CheckMaterialInCart/${item._id}`, //proxy uri
      {
        headers: {
            authorization:`Bearer ${ propsData.userData?.token }`,
            'Content-Type': 'application/json'
        } 
      })
      .then(res=>{
        //console.log(res.data);
        HandleAddedToCart(res.data.msg==="exist"?true:false)
      })
      .catch(error=>{
        console.log(error);
      })

  },[equilizer,item])

  let [LoadAddedToCart,HandleLoadAddedToCart]=useState(false)

  const AddToCart=()=>{
    HandleLoadAddedToCart(true)
    let data={
      materialId:item._id
    }
    axios.put(`${process.env.REACT_APP_URL}/api/user/AddRemoveMaterialCart`,data, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ propsData.userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
     // console.log(res.data);
     // HandleLoadAddedToCart(false)
      setEquilizer(equilizer+2)
    })
    .catch(error=>{
    //  console.log(error);
    })

  }

  return(
    <div 
      className='cartMaterialEach singleMaterialMinimized'
      >
               <div className='cartMaterialEachImage'>
                    <img src={`${item.images[0].fileUrl}`} width={"100%"} alt={"slider.pic"}/>
                </div>
                <div style={{  padding: "0px 30px 0px 30px"}}>
                    <Link   style={{color:"inherit",textDecoration:"none"}} to={`/materials/${item._id}`}><h3>{item?.name}</h3> </Link>
                    <div className='cartMaterialEachImageData'>
                        <div className='cartMaterialEachImageDataEachValue'>{formatNumberWithCommas(item.price)}</div>                      
                        <div className="cartMaterialEachImageDataRating">
                            <div><Rating name="half-rating-read" value={Math.round(AveregaRate * 10)/10} precision={0.5} readOnly /></div>
                             <div><IconButton onClick={AddToCart}><ShoppingCartIcon style={{color:AddedToCart&&"goldenrod"}}/></IconButton></div>  
                          </div>

                    </div>
                
                </div>
            
  </div>
  )
}

